import {priority} from '@priority-software/priority-proto-api/lib';
import {
    IReportSaveParams,
    datesFormats,
    generateReportsColumns,
    reportData,
    reportDel,
    reportList,
    reportSave,
    treeNodeChildern
} from './reports';
import {Report} from '../stores/ReportStore';
import {scalesFormName} from '../consts';
import {startForm} from '../../../services/form/form';
import {handleScreenMessage} from '../../Form/actions/screen';
import {ColumnsRs} from '../../Form/types';
import {getColumns} from '../../Form/actions/form';
import {Form} from '../../../stores/Form/Form';
import {addAndApplyFilters} from '../../Form/actions/filters';
import {prepareExpressionsToServer} from '../utils';
import {reportGeneratorsStore} from '../stores/ReportGeneratorsStore';

const checkErrors = res => {
    const errMessage = res.Messages?.find(
        msg => msg.MType === priority.netitems.shared.Message.Type.Error
    );
    if (errMessage) {
        throw new Error(errMessage.Text);
    }
};
export const getForms = async (): Promise<priority.netitems.nrest.ITreeNode[]> => {
    const entities = await treeNodeChildern(
        0,
        '0',
        priority.netitems.nrest.TreeNodeChildrenModes.TreeNodeChildrenModes_Forms
    );
    return entities.TreeNode;
};

export const getFormColums = async (
    nodeId: string
): Promise<priority.netitems.nrest.ITreeNode[]> => {
    const res = await treeNodeChildern(
        0,
        nodeId,
        priority.netitems.nrest.TreeNodeChildrenModes.TreeNodeChildrenModes_Both
    );

    return res.TreeNode;
};

export const getReportColumns = async (
    nodeId: string,
    reportId: number | Long
): Promise<{
    all: priority.netitems.nrest.ITreeNode[];
    selected: priority.netitems.nrest.ITreeNode[];
}> => {
    const res = await treeNodeChildern(
        reportId,
        nodeId,
        priority.netitems.nrest.TreeNodeChildrenModes.TreeNodeChildrenModes_Both
    );

    return {all: res.TreeNode || [], selected: res.SelectedColsInReport || []};
};
export const getReports = async (): Promise<priority.netitems.nrest.IReportTitle[]> => {
    const res = await reportList('0');
    checkErrors(res);
    return res.Title;
};

export const getReportData = async (reportId): Promise<priority.netitems.nrest.IReportData> => {
    const res = await reportData(reportId);
    if (res.Messages?.some(msg => msg.MType === priority.netitems.shared.Message.Type.Error)) {
        throw new Error();
    }
    return res?.data;
};

export const deleteReport = async (reportId: number | Long) => {
    const res = await reportDel(reportId);
    if (res.Messages?.some(msg => msg.MType === priority.netitems.shared.Message.Type.Error)) {
        throw new Error();
    }
    return res;
};

export const saveReport = async (report: Report) => {
    const newReport: IReportSaveParams = {
        Tabular: report.isTabular,
        RootNodeId: report.nodeId,
        Title: report.title,
        General: report.isGeneral,
        Vertical: report.isVertical,
        ReportId: report.reportId,
        Columns: prepareExpressionsToServer(report.columns),
        CopyOfReportId: report.duplicateId,
        InUse: report.isActive,
        LinkId: report.linkId,
        OuterJoin: report.savedOuterJoinId,
        ReportType: report.isUseAsChart
            ? priority.netitems.nrest.RepType.RepType_Chart
            : report.isUseAsDataset
            ? priority.netitems.nrest.RepType.RepType_DataSet
            : priority.netitems.nrest.RepType.RepType_Report
    };

    const res = await reportSave(newReport, {handleMessages: false});
    const {currentScreen} = reportGeneratorsStore;
    const {currentReport} = currentScreen;

    const hasErrors = res.Messages?.some(
        msg => msg.MType === priority.netitems.shared.Message.Type.Error
    );

    if (hasErrors && currentReport.reportId === 0) {
        currentReport.setReportId(res.ReportId);
    }

    checkErrors(res);

    return res?.ReportId;
};

export const getDateFormats = async (): Promise<priority.netitems.nrest.IDateFormat[]> => {
    const res = await datesFormats();
    return res?.Formats || [];
};

export const formStartHandler = async (formName: string): Promise<Form | null> => {
    const startRs: priority.netitems.form.StartRs = await startForm(formName);
    const isFormOk = await handleScreenMessage(startRs);

    if (isFormOk) {
        const columnsRs: ColumnsRs = await getColumns(startRs.Session, formName);
        const isColumnOk = await handleScreenMessage(columnsRs);
        if (isColumnOk) {
            const form: Form = new Form(formName, startRs, columnsRs, 0);
            return form;
        }
    }
    return null;
};

export const getScalesFormData = async () => {
    const eqOperator = priority.netitems.shared.ComparisonOperator.Eq;
    const filter = [{fieldId: 1, value: '*', operator: eqOperator}];

    const form = await formStartHandler(scalesFormName);
    const data = await addAndApplyFilters(form, filter);
    return data;
};

export const circularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};

interface ReportColumnsRS {
    columns: priority.netitems.nrest.IReportCol[];
    linkId: string;
}
export const generateReportColumns = async (
    nodeIds: string[],
    reportId: number | Long,
    linkid: string
): Promise<ReportColumnsRS> => {
    const res = await generateReportsColumns(nodeIds, reportId, linkid, {handleMessages: false});

    checkErrors(res);

    return {
        columns: res?.Columns,
        linkId: res?.LinkId
    };
};
